export const ENV_TYPES = {
  PRODUCTION: 'production',
  TEST: 'test',
  LOCAL: 'local',
  ALPHA: 'alpha',
} as const;

export type TEnvTypes = typeof ENV_TYPES[keyof typeof ENV_TYPES];
